import VueCharts from 'vue-chartjs';

require('chart.piecelabel.js');

export default {
    extends: VueCharts.Pie,
    mixins: [VueCharts.mixins.reactiveProp],
    props: ['chartData', 'interval', 'created'],
    data() {
        return {
            options: {
                tooltips: {
                    enabled: true,
                },
                responsive: true,
                maintainAspectRatio: false,
                legend: {
                    position: 'right',
                    align: 'center',
                    labels: {
                        generateLabels(chart) {
                            if (chart.data.labels.length && chart.data.datasets.length) {
                                return chart.data.labels.map((label, i) => {
                                    const meta = chart.getDatasetMeta(0);
                                    const ds = chart.data.datasets[0];
                                    const arc = meta.data[i];
                                    const custom = (arc && arc.custom) || {};
                                    const getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
                                    const arcOpts = chart.options.elements.arc;
                                    const fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                                    const stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                                    const bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

                                    // We get the value of the current label
                                    const value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];

                                    return {
                                        // Instead of `text: label,`
                                        // We add the value to the string
                                        text: `${label} : ${value}`,
                                        fillStyle: fill,
                                        strokeStyle: stroke,
                                        lineWidth: bw,
                                        hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                                        index: i,
                                    };
                                });
                            }
                            return [];
                        },
                    },
                },
                pieceLabel: {
                    fontColor: '#fff',
                    // position: 'outside',
                    render: 'label',
                },
            },
        };
    },
    methods: {
        loadChart() {
            let color = Chart.helpers.color;
            this.renderChart({
                labels: this.chartData.labels,
                datasets: [
                    {
                        data: this.chartData.results,
                        backgroundColor: this.chartData.background,
                        label: 'Dataset 1',
                    },
                ],
            }, this.options);
        },
        updateChart() {
            this._data._chart.data.labels = this.chartData.labels;
            this._data._chart.data.datasets[0].data = this.chartData.result.result;
        },
    },
    watch: {
        // created(newValue, oldValue) {
        //     this.loadChart();
        // },
    },
};
